/**
 * Source: MTU `LEAP LLP Ultimate Life_20260813 R01.xlsx`, revision R01
 * (SHA-256: 15d2dee4937e5a2b421e9e7756e8ec6b6ed3c3f13a1035cd986c3dc53d3b9887).
 * Part numbers and active limits come from `LEAP-1A Detail` CURRENT columns;
 * rating arrays come from `Thrust Mapping LEAP-1A`. MTU did not supply
 * LEAP-1A IINs, so this config leaves `iin` unset.
 *
 * Ultimate-Life limits (DR-3682) come from the same sheet's ULTIMATE columns:
 * `Ultimate Life Limit Low Thrust` → LOW_VARIANTS, `High Thrust` →
 * HIGH_VARIANTS, `XLR Rating` → XLR_VARIANTS — the same variant lists the
 * current limits use. They are transcribed below in that column order and
 * expanded into the grouped `partUltimateLimits` shape (limitKey → variant
 * keys) by the same `limitsByValue` helper. The value is the reachable ceiling,
 * so every P/N carries one — including those whose Ultimate equals the current
 * limit. `finalLimitPartNumbers` stays unset until MTU marks the P/Ns whose
 * ceiling CFMI fixed below Ultimate.
 */
const LOW_VARIANTS = ['1A23', '1A24', '1A24E1', '1A26', '1A26E1'];
const HIGH_VARIANTS = ['1A29', '1A30', '1A32', '1A33', '1A33B2', '1A35A'];
const XLR_VARIANTS = ['1A32X', '1A33X', '1A33B2X', '1A35AX'];
const NA = 'N/A';
/** P/N -> Ultimate-Life limits, transcribed in the sheet's LOW / HIGH / XLR column order. */
const ULTIMATE_LIMITS = {
    '362-040-010-0': [30000, 30000, 20000],
    '362-040-011-0': [30000, 30000, 20000],
    '362-045-010-0': [30000, 30000, 20000],
    '362-045-020-0': [30000, 30000, 20000],
    '362-500-230-0': [30000, 30000, 20000],
    '362-500-241-0': [30000, 30000, 20000],
    '2564M10G01': [17500, 17500, 10000],
    '2564M10G02': [20000, 17500, 10000],
    '2468M17P01': [17500, 17500, 10000],
    '2468M17P02': [20000, 17500, 10000],
    '2468M18G01': [17500, 17500, 10000],
    '2468M18G02': [20000, 17500, 10000],
    '2468M18G03': [20000, 17500, 10000],
    '2468M19P01': [20000, 17500, 10000],
    '2468M19P02': [17500, 17500, 10000],
    '2468M19P03': [20000, 17500, 10000],
    '2468M20G02': [10000, 10000, NA],
    '2468M20G03': [19100, 17000, 10000],
    '2468M20G05': [20000, 17500, 10000],
    '2468M20G06': [20000, 17500, 10000],
    '2468M20G07': [20000, 17500, 10000],
    '2468M46P01': [20000, 17500, 10000],
    '2466M58P01': [20000, 17500, 10000],
    '2466M58P03': [20000, 17500, 10000],
    '2085M69G02': [13300, 13300, NA],
    '2085M69G03': [13300, 13300, NA],
    '2621M72G01': [30000, 30000, 20000],
    '2621M72G02': [25000, 22000, NA],
    '2621M72G03': [30000, 30000, 20000],
    '2464M71G02': [12000, 12000, NA],
    '2464M71G03': [12000, 12000, NA],
    '2668M94G01': [30000, 30000, 20000],
    '2461M38P02': [3700, 3700, NA],
    '2461M38P03': [16800, 13400, 10000],
    '2784M30P01': [20000, 17500, 10000],
    '2466M62G02': [5100, 5100, NA],
    '2466M62G03': [19000, 16600, 10000],
    '2784M32G01': [20000, 12000, 10000],
    '2466M68P01': [10000, 10000, NA],
    '2466M68P02': [20000, 17500, 10000],
    '2466M68P03': [20000, 17500, 10000],
    '2466M68P04': [20000, 17500, 10000],
    '2466M52G02': [3000, 3000, NA],
    '2466M52G03': [20000, 17500, 10000],
    '2788M26G01': [20000, 17500, 10000],
    '2466M52G04': [20000, 17500, 10000],
    '2564M13P01': [15000, 15000, NA],
    '2564M13P02': [20000, 17500, 10000],
    '362-039-201-0': [5400, 5400, NA],
    '362-039-210-0': [30000, 30000, 20000],
    '362-039-211-0': [30000, 30000, 20000],
    '362-039-220-0': [30000, 30000, 20000],
    '362-039-221-0': [30000, 30000, 20000],
    '362-039-301-0': [5800, 5800, NA],
    '362-039-310-0': [30000, 30000, 20000],
    '362-039-311-0': [30000, 30000, 20000],
    '362-039-320-0': [30000, 30000, 20000],
    '362-039-321-0': [30000, 30000, 20000],
    '362-039-401-0': [7000, 7000, NA],
    '362-039-410-0': [30000, 30000, 20000],
    '362-039-411-0': [30000, 30000, 20000],
    '362-039-420-0': [30000, 30000, 20000],
    '362-039-421-0': [30000, 30000, 20000],
    '362-039-501-0': [5900, 5900, NA],
    '362-039-510-0': [30000, 30000, 20000],
    '362-039-511-0': [30000, 30000, 20000],
    '362-039-520-0': [30000, 30000, 20000],
    '362-039-521-0': [30000, 30000, 20000],
    '362-600-010-0': [9500, 9500, NA],
    '362-600-011-0': [30000, 30000, 20000],
    '362-600-012-0': [30000, 30000, 20000],
    '362-021-810-0': [30000, 30000, 20000],
    '362-021-811-0': [30000, 30000, 20000],
    '362-021-310-0': [20000, 15500, 20000],
    '362-021-330-0': [20000, 15500, 20000],
    '362-021-340-0': [30000, 30000, 20000],
    '362-021-341-0': [30000, 30000, 20000],
    '362-021-350-0': [30000, 30000, 20000],
    '362-035-610-0': [30000, 30000, 20000],
};
function limitsByValue(buckets) {
    const grouped = new Map();
    for (const [limitValue, variants] of buckets) {
        const key = String(limitValue);
        grouped.set(key, [...(grouped.get(key) ?? []), ...variants]);
    }
    return Object.fromEntries(grouped);
}
function ultimateLimitsFor(parts) {
    const partNumbers = new Set(parts.map(([partNumber]) => partNumber));
    return Object.fromEntries(Object.entries(ULTIMATE_LIMITS)
        .filter(([partNumber]) => partNumbers.has(partNumber))
        .map(([partNumber, [low, high, xlr]]) => [
        partNumber,
        limitsByValue([
            [low, LOW_VARIANTS],
            [high, HIGH_VARIANTS],
            [xlr, XLR_VARIANTS],
        ]),
    ]));
}
function component(componentName, parts) {
    return {
        componentName,
        partNumbers: parts.map(([partNumber]) => partNumber),
        partLimits: Object.fromEntries(parts.map(([partNumber, [low, high, xlr]]) => [
            partNumber,
            limitsByValue([
                [low, LOW_VARIANTS],
                [high, HIGH_VARIANTS],
                [xlr, XLR_VARIANTS],
            ]),
        ])),
        partUltimateLimits: ultimateLimitsFor(parts),
    };
}
export const leap_1a = {
    engineType: 'LEAP-1A',
    groups: [
        {
            groupName: 'Fan Module',
            components: [
                component('Fan Disk', [
                    ['362-040-010-0', [26000, 26000, 20000]],
                    ['362-040-011-0', [26000, 26000, 20000]],
                ]),
                component('LP Compressor Shaft', [
                    ['362-045-010-0', [30000, 30000, 20000]],
                    ['362-045-020-0', [30000, 30000, 20000]],
                ]),
                component('LP Compressor Spool', [
                    ['362-500-230-0', [30000, 30000, 20000]],
                    ['362-500-241-0', [30000, 30000, 20000]],
                ]),
            ],
        },
        {
            groupName: 'HPC Module',
            components: [
                component('Compressor Rotor Stage 1 Blisk', [
                    ['2564M10G01', [17500, 17500, 10000]],
                    ['2564M10G02', [20000, 17500, 10000]],
                ]),
                component('Compressor Rotor Stage 2 Blisk', [
                    ['2468M17P01', [17500, 17500, 10000]],
                    ['2468M17P02', [20000, 17500, 10000]],
                ]),
                component('Compressor Rotor Stages 3-4 Blisk', [
                    ['2468M18G01', [17500, 17500, 10000]],
                    ['2468M18G02', [20000, 17500, 10000]],
                    ['2468M18G03', [20000, 17500, 10000]],
                ]),
                component('Compressor Rotor Stage 5 Blisk', [
                    ['2468M19P01', [20000, 17500, 10000]],
                    ['2468M19P02', [17500, 17500, 10000]],
                    ['2468M19P03', [20000, 17500, 10000]],
                ]),
                component('Compressor Rotor Stages 6-10 Spool', [
                    ['2468M20G02', [10000, 10000, NA]],
                    ['2468M20G03', [19100, 17000, 10000]],
                    ['2468M20G05', [20000, 17500, 10000]],
                    ['2468M20G06', [20000, 17500, 10000]],
                    ['2468M20G07', [20000, 17500, 10000]],
                ]),
                component('Impeller Tube Support', [['2468M46P01', [20000, 17500, 10000]]]),
                component('Rotating Seal', [
                    ['2466M58P01', [20000, 17500, 10000]],
                    ['2466M58P03', [20000, 17500, 10000]],
                ]),
            ],
        },
        {
            groupName: 'HPT Module',
            components: [
                component('Combustion Case Assembly', [
                    ['2085M69G02', [13300, 13300, NA]],
                    ['2085M69G03', [13300, 13300, NA]],
                    ['2621M72G01', [18200, 15700, NA]],
                    ['2621M72G02', [13300, 13300, NA]],
                    ['2621M72G03', [17500, 17500, 15500]],
                ]),
                component('HPT Case', [
                    ['2464M71G02', [12000, 12000, NA]],
                    ['2464M71G03', [12000, 12000, NA]],
                    ['2668M94G01', [20000, 20000, 20000]],
                ]),
                component('Forward Outer Seal', [
                    ['2461M38P02', [3700, 3700, NA]],
                    ['2461M38P03', [16800, 13400, 7000]],
                    ['2784M30P01', [17600, 16500, 10000]],
                ]),
                component('HPT Rotor Stage 1 Disk', [
                    ['2466M62G02', [5100, 5100, NA]],
                    ['2466M62G03', [19000, 16600, 10000]],
                    ['2784M32G01', [14000, 12000, 10000]],
                ]),
                component('HPT Rotor Mid Seal', [
                    ['2466M68P01', [10000, 10000, NA]],
                    ['2466M68P02', [20000, 17500, 10000]],
                    ['2466M68P03', [20000, 17500, 10000]],
                    ['2466M68P04', [17500, 17500, 10000]],
                ]),
                component('HPT Rotor Stage 2 Disk', [
                    ['2466M52G02', [3000, 3000, NA]],
                    ['2466M52G03', [20000, 17500, 10000]],
                    ['2788M26G01', [20000, 17500, NA]],
                    ['2466M52G04', [20000, 17200, 10000]],
                ]),
                component('HPT Aft Rotating Seal', [
                    ['2564M13P01', [15000, 15000, NA]],
                    ['2564M13P02', [20000, 17500, 10000]],
                ]),
            ],
        },
        {
            groupName: 'LPT Module',
            components: [
                component('LP Turbine Stage 1 Disk', [
                    ['362-039-201-0', [5400, 5400, NA]],
                    ['362-039-210-0', [20000, 20000, 10000]],
                    ['362-039-211-0', [20000, 20000, 10000]],
                    ['362-039-220-0', [20000, 20000, 10000]],
                    ['362-039-221-0', [20000, 20000, 10000]],
                ]),
                component('LP Turbine Stage 2 Disk', [
                    ['362-039-301-0', [5800, 5800, NA]],
                    ['362-039-310-0', [20000, 20000, 10000]],
                    ['362-039-311-0', [20000, 20000, 10000]],
                    ['362-039-320-0', [20000, 20000, 10000]],
                    ['362-039-321-0', [20000, 20000, 10000]],
                ]),
                component('LP Turbine Stage 3 Disk', [
                    ['362-039-401-0', [7000, 7000, NA]],
                    ['362-039-410-0', [20000, 20000, 10000]],
                    ['362-039-411-0', [20000, 20000, 10000]],
                    ['362-039-420-0', [20000, 20000, 10000]],
                    ['362-039-421-0', [20000, 20000, 10000]],
                ]),
                component('LP Turbine Stage 4 Disk', [
                    ['362-039-501-0', [5900, 5900, NA]],
                    ['362-039-510-0', [20000, 20000, 10000]],
                    ['362-039-511-0', [20000, 20000, 10000]],
                    ['362-039-520-0', [20000, 20000, 10000]],
                    ['362-039-521-0', [20000, 20000, 10000]],
                ]),
                component('LP Turbine Stage 5 Disk', [
                    ['362-600-010-0', [9500, 9500, NA]],
                    ['362-600-011-0', [30000, 30000, 10000]],
                    ['362-600-012-0', [30000, 30000, 10000]],
                ]),
                component('LP Turbine Stages 6-7 Spool', [
                    ['362-021-810-0', [20000, 20000, 10000]],
                    ['362-021-811-0', [20000, 20000, 10000]],
                ]),
                component('LP Turbine Torque Cone', [
                    ['362-021-310-0', [20000, 15500, 8000]],
                    ['362-021-330-0', [20000, 15500, 8000]],
                    ['362-021-340-0', [17500, 17500, 9000]],
                    ['362-021-341-0', [17500, 17500, 9000]],
                    ['362-021-350-0', [17500, 17500, 9000]],
                ]),
                component('LP Turbine Shaft', [['362-035-610-0', [20800, 20800, 10000]]]),
            ],
        },
    ],
};
//# sourceMappingURL=leap-1a.js.map